/* External */
import {
  useCallback, useMemo, useRef, useEffect,
} from 'react';
import throttle from 'lodash-es/throttle';

/* Utils */
import { useDeviceInfo } from '../providers/DeviceInfoProvider';
import platform from '../utils/platform';
import { getMajorVersion } from '../utils/functions';

export default function useHandleThrottleArrowPress(handleArrowPress, delay = 40) {
  const { sdkVersion } = useDeviceInfo() || {};
  let delayArrowPress;

  if (platform.isWebOS && getMajorVersion(sdkVersion) === 3) {
    delayArrowPress = 500;
  } else if (platform.isVidaa) {
    delayArrowPress = 400;
  } else {
    delayArrowPress = delay;
  }

  const enableArrowPress = useRef(true);
  const updateEnableArrowPress = useMemo(() => throttle(() => {
    enableArrowPress.current = true;
  }, delayArrowPress, { leading: true, trailing: false }), [delayArrowPress]);

  const handleThrottleArrowPress = useCallback((...args) => {
    enableArrowPress.current = false;
    updateEnableArrowPress();
    if (enableArrowPress.current && handleArrowPress) {
      return handleArrowPress(...args);
    }
    return enableArrowPress.current;
  }, [handleArrowPress, updateEnableArrowPress]);

  useEffect(() => {
    const currentUpdateEnableArrowPress = updateEnableArrowPress;
    return () => {
      currentUpdateEnableArrowPress.cancel();
    };
  }, [updateEnableArrowPress]);

  return handleThrottleArrowPress;
}
